import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, inject } from '@angular/core';
import {MealKitCircularProgressBarComponent} from '@yoni/mealcomponents-lib';

import {ModalService} from '../../../Services/modal.service';
import {PerfoIndicator} from "../../../Services/qdm.service";


@Component({
  selector: 'app-modal-show-performances',
  templateUrl: './ModalShowPerformances.html',
  styleUrl: "./ModalShowPerformances.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MealKitCircularProgressBarComponent]
})
export class ModalShowPerformances implements OnDestroy {
  private variables = inject<any>('variables' as any);
  private modalService = inject(ModalService);
  private ref = inject(ElementRef);


  perfos: PerfoIndicator[] = [];
  monthName: string = "";

  ngOnInit(): void {
    this.perfos = this.variables.perfos || [];
    this.monthName = this.variables.monthName || '';

    this.ref.nativeElement.addEventListener('click', (ev: any) => {
      if (ev.target === this.ref.nativeElement) {
        this.modalService.close();
      }
    });

  }


  ngOnDestroy(): void {
  }

  close(ev?: MouseEvent) {
    if (!ev) {
      this.modalService.close();
      return;
    }

    if (ev.target === ev.currentTarget) {
      this.close();
    }
  }
}
